/**
 * Route definitions
 */
export const routes = {
  powerCardPlans: "/electricity-plans",
  energyBotScreen: "/energy-bot-screen",
  home: "/",
  landing: "/landing",
  about: "/about",
  howItWorks: "/how-it-works",
  newsFeed: "/news-feed",
  pricing: "/pricing",
  referAndEarn: "/refer-and-earn",
  notifications: "/notifications",
  andyNotifications: "/notifications/andy",
  chatNotifications: "/notifications/chat",
  faq: "/faq",
  login: "/login",
  signup: "/signup",
  forgotPassword: "/forgot-password",
  emailVerificationPending: "/email-verification-pending",
  forceMobileUpdate: "/force-mobile-update",
  forcePasswordUpdate: "/force-password-update",
  emailVerificationRequired: "/verify-email",
  phoneVerification: "/phone-verification",
  phoneMobileInput: "/verify-mobile",
  dashboard: "/dashboard",
  profile: "/profile",
  properties: "/properties",
  propertiesDetail: "/properties/:propertyId",
  propertiesSearch: "/properties-search",
  selectPropertyType: "/select-property-type",
  protestPayment: "/protest-payment",
  paymentSuccess: "/payment/success",
  paymentCancel: "/payment/cancel",
  homesteadExemption: "/homestead-exemption",
  homepage: "/home",
  settings: "/settings",
  settingsAccount: "/settings/account",
  settingsHome: "/settings/home",
  settingsProperties: "/settings/properties",
  settingsProtestHistory: "/settings/protest-history",
  settingsAutopaySubscription: "/settings/autopay-subscription",
  settingsHistoricalAchievements: "/settings/historical-achievements",
  settingsAppSettings: "/settings/app-settings",
  settingsContactUs: "/settings/contact-us",
  settingsContactUsChat: "/settings/contact-us/chat",
  settingsLogout: "/settings/logout",
} as const;

export type Route = (typeof routes)[keyof typeof routes];

/** Router `location.state` for `/select-property-type` (see `useSelectPropertyTypePageViewModal`). */
export type SelectPropertyTypeLocationState = {
  /** When true (e.g. home journey "Supporting Documents"), open the supporting-docs stepper instead of staying on the property-type page only. */
  openProtestSupportingDocuments?: boolean;
  paidPropertyIds?: string[];
  paidProperties?: unknown[];
  customerEmail?: string;
  isGuest?: boolean;
};
